if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.cart = document.querySelector('cart-drawer');

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['Accept'] = 'application/json';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          const sectionIds = this.cart.getSectionsToRender().map((section) => section.id);
          formData.append('sections', sectionIds.join(','));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const cartAddUrl = routes.cart_add_url.includes('.js')
          ? routes.cart_add_url
          : `${routes.cart_add_url}.js`;

        fetch(cartAddUrl, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              const variantId = String(formData.get('id') || '');
              const isMaxInCartError = this.isMaxInCartError(response);
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });

              if (isMaxInCartError) {
                this.showProductQuantityError(response.description);
                this.lockComplementaryQuickAddButton();
                this.showStockLevelForVariant(variantId);
                this.error = false;
                return;
              }

              this.handleErrorMessage(response.description);

              const cardSoldOut = this.closest('.complementary-product-card')?.querySelector('[data-comp-sold-out]');
              if (cardSoldOut) {
                this.submitButton.setAttribute('aria-disabled', true);
                cardSoldOut.removeAttribute('hidden');
                cardSoldOut.setAttribute('role', 'alert');
                this.error = true;
                return;
              }

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      showProductQuantityError(errorMessage) {
        const quantityInput = this.closest('product-info')?.querySelector(
          'quantity-input[data-quantity-error-id]'
        );
        quantityInput?.showQuantityError(errorMessage);
      }

      isMaxInCartError(response) {
        const combined = [response?.description, response?.message, response?.errors]
          .filter(Boolean)
          .join(' ')
          .toLowerCase();
        if (!combined) return false;

        return (
          combined.includes('plus de') ||
          combined.includes('maximum') ||
          combined.includes('maximale') ||
          combined.includes("can't add more") ||
          combined.includes('already in your cart')
        );
      }

      lockComplementaryQuickAddButton() {
        if (!this.closest('.complementary-product-card')) return;
        this.submitButton.setAttribute('aria-disabled', 'true');
        if (!this.closest('.complementary-products--pack-source')) {
          this.submitButton.setAttribute('disabled', 'disabled');
        }
      }

      showStockLevelForVariant(variantId) {
        if (!variantId) return;
        const escapeSelector = (value) => {
          if (window.CSS?.escape) return window.CSS.escape(value);
          return value.replace(/["\\]/g, '\\$&');
        };
        const selector = `[data-quantity-variant-id="${escapeSelector(variantId)}"]`;
        const quantityInput = document.querySelector(`#CartDrawer-CartItems ${selector}, #main-cart-items ${selector}`);
        const lineIndex = quantityInput?.dataset?.index;
        if (!lineIndex) return;

        const stockLevelEl =
          document.getElementById(`CartDrawer-LineItemStockLevel-${lineIndex}`) ||
          document.getElementById(`LineItemStockLevel-${lineIndex}`);
        if (!stockLevelEl) return;

        stockLevelEl.classList.remove('hidden');
        stockLevelEl.removeAttribute('hidden');
        stockLevelEl.setAttribute('role', 'alert');

        if (window.__complementaryStockLevelTimer) {
          window.clearTimeout(window.__complementaryStockLevelTimer);
        }
        window.__complementaryStockLevelTimer = window.setTimeout(() => {
          stockLevelEl.classList.add('hidden');
          stockLevelEl.setAttribute('hidden', '');
          stockLevelEl.removeAttribute('role');
          window.__complementaryStockLevelTimer = null;
        }, 2500);
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) {
            this.submitButtonText.textContent = text;
            this.submitButton.classList.remove('product-form__submit--sold-out');
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
          this.submitButton.classList.remove('product-form__submit--sold-out');
        }
      }

      syncSubmitButton(sourceButton) {
        if (!this.submitButton || !sourceButton) return;

        if (sourceButton.hasAttribute('disabled')) {
          this.submitButton.setAttribute('disabled', 'disabled');
        } else {
          this.submitButton.removeAttribute('disabled');
        }

        const sourceText = sourceButton.querySelector('span')?.textContent?.trim();
        if (sourceText && this.submitButtonText) {
          this.submitButtonText.textContent = sourceText;
        }

        this.submitButton.classList.toggle(
          'product-form__submit--sold-out',
          sourceButton.classList.contains('product-form__submit--sold-out')
        );
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
